<template>
  <div class="support">
    <div class="support-div">
      <div class="support-header">
        <h2>پشتیبانی</h2>
        <button @click.prevent="showModal = !showModal" class="submit">
          <img src="@/assets/icons/Plus.svg" alt="" />
          تیکت جدید
        </button>
      </div>
      <TheTablePanelSupport :key="$route.query.page" />
    </div>
    <transition name="fade">
      <SupportModal v-if="showModal" @close="closemodal" />
    </transition>
  </div>
</template>

<script>
import TheTablePanelSupport from "./TheTablePanelSupport";
import SupportModal from "./SupportModal";

export default {
  name: "Support",
  components: { TheTablePanelSupport, SupportModal },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    closemodal() {
      this.showModal = false;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.support {
  .support-div {
    background-color: var(--box);
    border-radius: 5px;
    margin-bottom: 10px;
    width: 100%;
    padding: 20px;

    .support-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-bottom: 26px;
      .submit {
        width: 104px;
        height: 36px;
        display: flex;
        align-items: center;
        padding: 8px;
        img {
          margin-left: 8px;
        }
      }

      .close {
        width: 43px;
        height: 43px;
        border: 1px solid var(--yellow);
        border-radius: 5px;
      }
    }
  }
}
</style>
